<fidelity-overlay-page-wrapper
    *transloco="let t; prefix 'fidelity-app'"
    [headerCaption]="t('account.security.heading')"
>
    <div
        pageContent
        class="p-4 min-h-1/4 flex flex-col h-full"
    >
        <h2>{{ t('account.security.title') }}</h2>
        <div [formGroup]="passwordForm" class="w-full grid grid-cols-1 gap-y-4 mt-4">
            <!-- Old password -->
            <mat-form-field>
                <mat-label>
                    {{ t('account.security.current-password') }}
                </mat-label>
                <input
                    matInput
                    type="password"
                    formControlName="currentPassword"
                    autocomplete="current-password"
                >
            </mat-form-field>

            <!-- New password -->
            <mat-form-field>
                <mat-label>
                    {{ t('account.security.new-password') }}
                </mat-label>
                <input
                    matInput
                    type="password"
                    formControlName="newPassword"
                    #newPasswordField
                >
                <button
                    mat-icon-button
                    type="button"
                    (click)="
                            newPasswordField.type === 'password'
                                ? (newPasswordField.type = 'text')
                                : (newPasswordField.type = 'password')
                        "
                    matSuffix
                >
                    @if (newPasswordField.type === 'password') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                    }
                    @if (newPasswordField.type === 'text') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                    }
                </button>
            </mat-form-field>

            <!-- Confirm new password -->
            <mat-form-field>
                <mat-label>
                    {{ t('account.security.confirm-new-password') }}
                </mat-label>
                <input
                    matInput
                    type="password"
                    formControlName="confirmNewPassword"
                    #newPasswordField
                >
                <button
                    mat-icon-button
                    type="button"
                    (click)="
                            newPasswordField.type === 'password'
                                ? (newPasswordField.type = 'text')
                                : (newPasswordField.type = 'password')
                        "
                    matSuffix
                >
                    @if (newPasswordField.type === 'password') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye'"
                        ></mat-icon>
                    }
                    @if (newPasswordField.type === 'text') {
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_solid:eye-slash'"
                        ></mat-icon>
                    }
                </button>
            </mat-form-field>

            <button
                class="fuse-mat-button-large mt-6 w-full enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                mat-flat-button
                [disabled]="disableSave()"
                (click)="saveChanges()"
            >
                @if (!disableCrudActions()) {
                    <span>
                        {{ t('account.security.change-pw') }}
                    </span>
                } @else {
                    <mat-progress-spinner
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                }
            </button>
        </div>

        <div class="text-secondary pt-2 mt-6 border-t w-full" [innerHTML]="t('account.security.pw-rules') | safe">
        </div>
    </div>
</fidelity-overlay-page-wrapper>
